export const assignedTasksRelationship = {
    collapsible: false,
    title: 'Tasks',
    tint: 'default',
    type: 'workplan_tasks',
};
